import React from 'react';

import './ProgressBar.css';

const mainBgColor = '#f5f5f5';

export default ({ steps, percentage, strokeColors }) => {
  const getStepBGColor = () => {
    const colorIndex = steps.findIndex(step => percentage <= step);
    return strokeColors[colorIndex === -1 ? strokeColors.length - 1 : colorIndex];
  };
  return (
    <div className="ProgressBar">
      <div className="stepsContainer">
        <div className="step step_last" style={{ background: getStepBGColor() }} />
        <div className="stepsContainerBg" style={{ background: `${mainBgColor}`, zIndex: `${steps.length + 2}`, width: `${100 - percentage}%` }} />
      </div>
    </div>
  );
};
